import { SegmentedControlButton } from './style';

export interface SegmentedControlItemProps {
    value: string;
    onChange?: (e: React.MouseEvent<HTMLButtonElement>, value: string) => void;
    label?: React.ReactNode | string;
    name?: string;
    disabled?: boolean;
    checked?: boolean;
    itemWidth?: 'evenly' | 'content';
}

export const SegmentedControlItem = ({
    checked,
    disabled,
    onChange,
    value,
    name = '',
    label,
    itemWidth = 'evenly',
    ...other
}: SegmentedControlItemProps) => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (onChange) {
            onChange(event, value);
        }
    };

    return (
        <SegmentedControlButton
            data-test-item-switch={`${name}-${value}`}
            checked={checked}
            disabled={disabled}
            onClick={handleClick}
            tabIndex={0}
            role="tab"
            aria-selected={checked}
            itemWidth={itemWidth}
            {...other}
        >
            {label}
        </SegmentedControlButton>
    );
};
